export const getCurrentUser = (state) => state.user;

export const isAdmin = (state) => state.user && state.user.type === 'admin';
